import PropTypes from "prop-types";
import { useLocales } from "../../../../locales";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from "@fortawesome/fontawesome-svg-core/import.macro";

export function PlatformRow({ metricConfig, data, info_text }) {
  const { translate: t, currentLang } = useLocales();

  return (
    <div
      className="border border-gray-300 border-dashed rounded py-2 px-4 mb-2  "
      key={metricConfig.key}
    >
      <div className=" d-flex">
        <div className="mr-3 me-3">
          <i className={`${metricConfig.icon} fs-1x text-primary`} />
        </div>
        <div className="w-100">
          <div
            className={
              "d-flex justify-content-between align-items-center w-100"
            }
          >
            <div className="m-0 fw-bold align-self-start">
              {t(`overallCard.${metricConfig?.title}`)}
            </div>
            <div className={"px-2 text-muted"}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{t(`analyticsCards.${info_text}`)}</Tooltip>}
              >
                <i className="fa-duotone fa-circle-info fa-sm"></i>
              </OverlayTrigger>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <p className="m-0 fs-1x fw-bold ml-6">
              {data &&
                new Intl.NumberFormat(currentLang.value, {}).format(
                  Math.ceil(data?.displayValue)
                )}
            </p>
            {data && (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    <span className={"me-2"}>
                      {t("overallCard.value_before")}:
                    </span>
                    {data
                      ? new Intl.NumberFormat(currentLang.value, {}).format(
                          Math.ceil(data?.oldValue)
                        )
                      : "-"}
                  </Tooltip>
                }
              >
                <div className="d-flex align-items-center">
                  {!data?.oldValue && data?.oldValue !== 0 ? (
                    <div className="m-0">
                      <span className="badge badge-sm badge-light">-</span>
                    </div>
                  ) : data.displayPercentage === 0 ? (
                    <div className="m-0">
                      <span className="badge badge-sm badge-light">
                        {data.displayPercentage} %
                      </span>
                    </div>
                  ) : (
                    <div className="m-0">
                      <span
                        className={`badge ${
                          data?.trend < 0
                            ? "badge-light-danger"
                            : "badge-light-success"
                        }`}
                      >
                        <i
                          className={`fa-duotone ${
                            data?.trend < 0
                              ? "fa-arrow-down text-danger"
                              : "fa-arrow-up text-success"
                          } fs-5 ms-n1 me-2`}
                        ></i>
                        {data.displayPercentage} % | {new Intl.NumberFormat(currentLang.value, {}).format(
                          Math.ceil(data?.displayValue - data.oldValue)
                      )}
                      </span>
                    </div>
                  )}
                </div>
              </OverlayTrigger>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

PlatformRow.propTypes = {
  metricConfig: PropTypes.object,
  data: PropTypes.object,
  info_text: PropTypes.string,
};
